import { useQuery } from '@tanstack/react-query'
import { QUERY_KEY } from '../utils/constants'
import { fetchMenuItem, fetchSidebarMenu } from '../api/menuApi'

export const useMenu = (options = {}) => {
    return useQuery({
        queryKey: [QUERY_KEY.GetMenuItems],
        queryFn: async () => {
            const resp = await fetchMenuItem()
            return resp
        },
        ...options
    })
}

export const useSideBarMenu = (options = {}) => {
    return useQuery({
        queryKey: [QUERY_KEY.GET_SIDEBAR_MENU],
        queryFn: async () => {
            const resp = await fetchSidebarMenu()
            return resp
        },
        ...options
    })
}
